exports.routes = {
    login: `/sign-in`,
    signup: `/sign-up`,
    staffRegister: `/staff/sign-up`,
    dashboard: `/staff/dashboard`,
    message: `/staff/message`,
    staffMessage: `/staff/message/id`,
    providerMessage: `/staff/message/id`,
    myJobs: `/staff/jobs`,
    paymentSuccess: `/staff/jobs/payment-success`,
    paymentError: `/staff/jobs/payment-error`,
    lockedJobs: `/staff/locked/jobs`,
    jobDetails: `/staff/job/info`,
    careNetwork: `/staff/care-network`,
    careNetworkDetails: `/staff/care-network/info`,
    appliedJob: `/staff/care-network/applied-job`,
    advertisement: `/staff/advertisement`,
    postedAdvertisement: `/staff/advertisement/posted`,
    advertisementDetails: `/staff/advertisement/info`,
    networkDirectory: `/staff/network-directory`,
    userDetail: `/staff/network-directory/info`,
    profile: `/staff/profile`,
    calendar: `/staff/calendar`,
    subscriptionPlan: `/staff/subscription-plan`,
    newsletter: `/staff/newsletter`,
    aboutUs: `/staff/about-us`,
    privacyPolicy: `/staff/privacy-policy`,
    termsCondition: `/staff/terms-condition`,
    contactUs: `/staff/contact-us`,
    transactionList: `/staff/transaction-history`,
    reviewList: `/staff/reviews`,

    expenseDashboard: `/staff/expenses/dashboard`,
    expenseCreate: `/staff/expenses/create`,
    expenseEdit: `/staff/expenses/edit`,
    expenseList: `/staff/expenses/listing`,
    budgetList: `/staff/expenses/budget/listing`,

    communityDashboard: `/staff/community/dashboard`,
    communitySuggested: `/staff/suggested/community`,
    communityFollowing: `/staff/community/following`,
    communityList: `/staff/community/list`,
    communityInfo: `/staff/community/info`,
    communityPostInfo: `/staff/community/post/info`,
    communityShareProfile: `/staff/community/share/profile`,
    
    careLoyalty: `/staff/care-loyalty`,
}